import React, { useEffect, useRef } from 'react';

import { PopupModal } from 'react-calendly';

import { useBodyScrollBlock } from '@/hooks/use-body-scroll-block';
import { CALENDLY_URL } from '@/utils/constants';

type CalendlyModalProps = {
  open: boolean;
  onClose: () => void;
};

const CalendlyModal = ({ open, onClose }: CalendlyModalProps) => {
  const body = useRef<HTMLElement | null>();
  useBodyScrollBlock(open);

  useEffect(() => {
    if (window) {
      body.current = document.getElementById('__next');
    }
  }, []);

  if (body.current) {
    return (
      <PopupModal url={CALENDLY_URL} onModalClose={onClose} open={open} rootElement={body.current as HTMLBodyElement} />
    );
  }
  return null;
};

export default CalendlyModal;
